/**
 * Who may VIEW another user's screen: CEO, any Director, or a Developer.
 * Mirrors the backend `is_screenshare_viewer`. Accepts both the auth user and
 * the lighter InternalUser shape from the user picker.
 */
export function isScreenShareViewer(
  u: { is_ceo?: boolean; role?: string; is_developer?: boolean } | null | undefined,
): boolean {
  return !!u && (!!u.is_ceo || u.role === "director" || !!u.is_developer);
}

/**
 * Screen share is an internal-only feature — external contractors don't take
 * part (they can't browse the internal user directory and must not appear in
 * the picker / presence roster). Mirrors AronDockHost's contractor gate.
 */
export function canUseScreenShare(u: { role?: string } | null | undefined): boolean {
  return !!u && u.role !== "contractor";
}
